// extracted by mini-css-extract-plugin
export var boxItems = "_25-1";
export var boxItemsLg = "_25-2";
export var button = "_25-7";
export var buttonHoverless = "_25-9";
export var buttonLg = "_25-8";
export var filterGroupBox = "_25-0";
export var icon = "_25-3";
export var iconSecondary = "_25-6";
export var iconWrapper = "_25-4";
export var iconWrapperLg = "_25-5";
export var truncatedLabel = "_25-a";